import { Box, Button, CircularProgress, Divider, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import PopupContent from "./PopupContent/PopupContent";
import { NavigateBeforeRounded, NavigateNextRounded } from "@mui/icons-material";
import axios from "axios";
import { GlobalState } from "context/GlobalContext";
import { AuthState } from "context/AuthContext";
import {
	cbChannelsizeQtyAssoc,
	colorBuyingChannelsAssoc,
	colorBuyTableColumns,
} from "components/PimDashboard/DashboardComponents/Buying/BuyingSheet/data";
import { inputTypes, publishColumns, statusOptions } from "data/globalData";
import { buyingSheetPath, productionStageOptions } from "components/PimDashboard/data";
import moment from "moment";
import { BuyingDashboardState } from "context/BuyingDashboardContext";
import { useNavigate, useSearchParams } from "react-router-dom";

const SelectedBuying = ({}) => {
	const navigate = useNavigate();
	const { setLoadingOpen, setSnackBarOpen, setSnackBar, snackBar } = GlobalState();
	const { user } = AuthState();
	const { buyingList, setBuyingList } = BuyingDashboardState();

	const [searchParams, setSearchParams] = useSearchParams();

	const [itemIndex, setItemIndex] = useState(() => {
		const id = +searchParams.get("id");
		if (id) {
			return buyingList?.findIndex((row) => row.id === id);
		} else return 0;
	});
	const [updatedBuyData, setUpdatedBuyData] = useState();
	const [deletedSizesId, setDeletedSizesId] = useState();
	const [rowOriginalState, setRowOriginalState] = useState();
	const [isUpdated, setIsUpdated] = useState(false);
	const [loading, setLoading] = useState(false);

	const disableAll =
		buyingList?.[itemIndex]?.status === statusOptions?.PUBLISHED.key ||
		buyingList?.[itemIndex]?.stage !== productionStageOptions?.BUYING.key;
	const getBuyingData = async () => {
		const buying_id = buyingList[itemIndex].id;
		if (buying_id) {
			setLoading(true);
			try {
				let res = await axios.get(`/api/color_buying/buying_qty_data/${buying_id}`);
				setUpdatedBuyData(res.data);
				setRowOriginalState({ ...res.data });
				setLoading(false);
			} catch (error) {
				console.log(error);
				setUpdatedBuyData();
				setLoading(false);
			}
		}
	};
	// handle rowdata on index change
	useEffect(() => {
		if (buyingList.length > 0) getBuyingData();
	}, [itemIndex]);

	const handleNextClick = () => {
		if (itemIndex < buyingList?.length - 1) {
			setItemIndex(itemIndex + 1);
			setSearchParams({ id: itemIndex + 1 });
			setIsUpdated(false);
		} else {
			navigate(`/${buyingSheetPath}`);
		}
	};
	const handlePrevClick = () => {
		if (itemIndex > 0) {
			setItemIndex(itemIndex - 1);
			setSearchParams({ id: itemIndex - 1 });

			setIsUpdated(false);
		}
	};
	const handleUpdateData = (updated) => {
		setUpdatedBuyData(updated);
		setBuyingList((prev) => {
			const updatedList = [...prev];
			updatedList[itemIndex] = { ...updatedList[itemIndex], ...updated };
			return updatedList;
		});
		setSnackBarOpen(true);
		setSnackBar({
			...snackBar,
			message: `Saved ${updated?.status === statusOptions.PUBLISHED.key ? "and Published Successfully" : ""} Successfully `,
			severity: "success",
			anchorOrigin: { horizontal: "center", vertical: "top" },
		});
		setLoadingOpen(false);
		setIsUpdated(false);
	};

	const handleUpdateBuinyQty = async (body) => {
		setLoadingOpen(true);
		try {
			await axios.post("/api/color_buying/update_color_buying", body).then((res) => {
				// console.log("get_size_type_master", res?.data);
				handleUpdateData(body);
				handleNextClick();
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Server Error for size types `,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};
	const handleSaveClick = (isPub) => {
		let buy_total_qty = 0;
		// handling Size type updates
		const userEmail = user.email;

		// handling final mrp
		let mrp = parseInt(updatedBuyData?.[colorBuyTableColumns.final_mrp.key]) ?? 0;
		let mrpChanged =
			buyingList[itemIndex]?.[colorBuyTableColumns.final_mrp.key] !== mrp && mrp !== 0
				? userEmail
				: buyingList[itemIndex]?.[colorBuyTableColumns.mrp_updated_by.key];
		let pubChanged =
			buyingList[itemIndex]?.[publishColumns.status.key] !== (isPub ? statusOptions.PUBLISHED.key : statusOptions.CREATED.key)
				? userEmail
				: buyingList[itemIndex]?.[publishColumns.published_by.key];

		const allChWithTotalQty = updatedBuyData?.[colorBuyingChannelsAssoc]?.map((row) => {
			let total = 0;
			row?.[cbChannelsizeQtyAssoc]?.forEach((row) => {
				total += row?.total_qty;
			});
			buy_total_qty += total;
			return { ...row, total_qty: total };
		});
		let body = {
			...updatedBuyData,
			total_qty: buy_total_qty,
			[colorBuyTableColumns.final_mrp.key]: mrp,
			[colorBuyTableColumns.mrp_updated_by.key]: mrpChanged,
			[colorBuyingChannelsAssoc]: allChWithTotalQty,
			sizeIdsToDelete: deletedSizesId,
		};
		console.log(updatedBuyData, body, "hgsdjfhksad");

		if (isPub)
			body = {
				...body,
				stage: productionStageOptions.SOURCING.key,
				published_by: pubChanged,
				status: statusOptions.PUBLISHED.key,
				published_date: moment().format("YYYY-MM-DD"),
			};

		handleUpdateBuinyQty(body);
	};

	const handleCancelEditClick = () => {
		setUpdatedBuyData(rowOriginalState);
		setIsUpdated(false);
	};
	console.log("dskjfhasli", deletedSizesId);
	return (
		<Box>
			{/* <Divider sx={{ marginTop: "auto" }} /> */}
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					boxSizing: "border-box",
					position: "fixed",
					top: "70px",
					right: "0px",
					minWidth: "400px",
					zIndex: +1000,
					background: "white",
					p: 1,
					borderRadius: "2px",
					// boxShadow: 1,
					// border: `1px solid ${grey[200]}`,
				}}>
				<Typography variant="body1" fontSize={12} fontWeight={400}></Typography>
				<Stack direction="row" columnGap={1}>
					<Typography variant="h6" pr={3}>
						{itemIndex + 1} / {buyingList?.length}
					</Typography>

					<Box display="flex" columnGap={1}>
						<Button
							variant="outlined"
							startIcon={<NavigateBeforeRounded />}
							autoFocus
							onClick={handlePrevClick}
							disabled={itemIndex === 0}>
							Prev
						</Button>
						<Button
							endIcon={<NavigateNextRounded />}
							variant="contained"
							autoFocus
							onClick={handleNextClick}
							disabled={itemIndex === buyingList?.length - 1}>
							Next
						</Button>
					</Box>
					<Button
						variant="contained"
						disabled={disableAll}
						onClick={() => {
							handleSaveClick(true);
						}}>
						Publish
					</Button>
				</Stack>
			</Box>
			<Divider sx={{ marginTop: "auto", pt: 1 }} />

			<Box minHeight="80vh" pt={1}>
				{loading ? (
					<Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center">
						<CircularProgress size="50px" />
					</Box>
				) : (
					<PopupContent
						currentBuyStaticData={buyingList ? buyingList[itemIndex] : {}}
						updatedBuyData={updatedBuyData}
						setUpdatedBuyData={setUpdatedBuyData}
						// handleCloseModal={}
						isUpdated={isUpdated}
						setIsUpdated={setIsUpdated}
						setDeletedSizesId={setDeletedSizesId}
					/>
				)}
			</Box>
		</Box>
	);
};

export default SelectedBuying;
